export default __webpack_public_path__ + "static/media/3031 spice rack B top.02fb0592.png";